import React from 'react';
import MyAppsTab from './dashboard/MyAppsTab';

// /applications/all — your apps & plugins, as an Instagram-style list with
// an Applications / Plugins tab switcher. Rendered inside the portal shell.
export default function MyApplicationsPage() {
  return (
    <div className="standalone-page ofself-page-fade">
      <MyAppsTab routed />
    </div>
  );
}
